export enum CommentStatus {
  ACTIVE = 'ACTIVE',
  HIDDEN = 'HIDDEN',
  DELETED = 'DELETED',
  BLOCKED = 'BLOCKED',
}

export enum PaginatedCommentOrder {
  POPULAR = 'popular',
  LATEST = 'latest',
}
